const GASearchCategory: string = 'Search';
const GACompletedSearch: string = 'search_completed';
const GASearchFailed: string = 'search_failed';

export default GASearchCategory;
export { GASearchCategory, GACompletedSearch, GASearchFailed };
